import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { forum: { GET_CATEGORIES } } = queries;
const { forum: { ADD_CATEGORY } } = mutations;
const DEFAULT_ORDER = 0;
const usePrepareComponent = () => {
    const history = useHistory();
    const [addContent, { loading }] = useMutation(ADD_CATEGORY, {
        refetchQueries: [GET_CATEGORIES]
    });
    const [getContents] = useLazyQuery(GET_CATEGORIES);
    const onCancel = () => {
        history.push("/forum/categories");
    };
    const onSave = (itemAdd) => {
        addContent({
            onCompleted: () => {
                getContents({
                    fetchPolicy: "network-only",
                    onCompleted: () => {
                        history.push("/forum/categories");
                    }
                });
            },
            variables: {
                category: {
                    ...itemAdd,
                    description: itemAdd.description ?? "",
                    name: itemAdd.name ?? "",
                    order: itemAdd.order ?? DEFAULT_ORDER,
                    sectionId: itemAdd.sectionId ?? "",
                    slug: itemAdd.slug ?? ""
                }
            }
        });
    };
    return {
        loading,
        onCancel,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Add);
